import React from 'react';

import { Svg, SvgRect } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const svgStyle = { width: '100%', height: '100%', position: 'absolute' } as any;

export const Background = ({ desktop }: { desktop: boolean }) => (
  <Svg
    width="375"
    height="812"
    viewBox="0 0 375 812"
    fill="none"
    preserveAspectRatio="xMinYMin slice"
    style={svgStyle}
  >
    <SvgRect y="0%" width="100%" height={desktop ? '2%' : '4%'} fill={primitive.$mayoEggWhite} />
    <SvgRect y={desktop ? '2%' : '4%'} width="100%" height={desktop ? '2%' : '4%'} fill="#FF8732" />
    <SvgRect y={desktop ? '4%' : '8%'} width="100%" height={desktop ? '2%' : '4%'} fill="#BD0A00" />
    <SvgRect
      y={desktop ? '6%' : '12%'}
      width="100%"
      height={desktop ? '94%' : '88%'}
      fill={primitive.$bbqBrown}
    />
  </Svg>
);
